module.exports = __webpack_public_path__ + "c41c5f923dfa872f3d25d1134eb53715.MP3";